export default "__VITE_ASSET__nNq6IZ8a__"